import type { TDeal } from '../model/deal';
import type { TInWorkOrFinishedDealsQueryParams } from '../model/in-work-or-finished-deals';
import type { TLostDealsQueryParams } from '../model/lost-deals';
import type { TPostponedDealsQueryParams } from '../model/postponed-deals';

export const dealQueryKeys = {
    all: ['deal'] as const,
    returnToBoard: (dealIds: readonly TDeal['id'][]) =>
        [...dealQueryKeys.all, 'return-to-board', ...dealIds] as const,
    detail: (dealId: TDeal['id']) => [...dealQueryKeys.all, dealId] as const,
    updateDetails: () => [...dealQueryKeys.all, 'details', 'update'] as const,
    createComment: (dealId: TDeal['id']) =>
        [...dealQueryKeys.detail(dealId), 'comments', 'create'] as const,
    deleteComment: (dealId: TDeal['id']) =>
        [...dealQueryKeys.detail(dealId), 'comments', 'delete'] as const,
    commentsPoll: (dealId: TDeal['id']) =>
        [...dealQueryKeys.detail(dealId), 'comments', 'poll'] as const,
    lists: {
        all: () => [...dealQueryKeys.all, 'list'] as const,
    },
    postponedDeals: {
        all: () => [...dealQueryKeys.lists.all(), 'postponed'] as const,
        list: (queryParams: TPostponedDealsQueryParams) =>
            [...dealQueryKeys.postponedDeals.all(), queryParams] as const,
        updateDeal: (dealId: TDeal['id']) =>
            [...dealQueryKeys.postponedDeals.all(), 'update', dealId] as const,
    },
    lostDeals: {
        all: () => [...dealQueryKeys.lists.all(), 'lost'] as const,
        list: (queryParams: TLostDealsQueryParams) =>
            [...dealQueryKeys.lostDeals.all(), queryParams] as const,
        updateDeal: (dealId: TDeal['id']) =>
            [...dealQueryKeys.lostDeals.all(), 'update', dealId] as const,
    },
    inWorkOrFinishedDeals: {
        all: () => [...dealQueryKeys.lists.all(), 'in-work-or-finished'] as const,
        list: (queryParams: TInWorkOrFinishedDealsQueryParams) =>
            [...dealQueryKeys.inWorkOrFinishedDeals.all(), queryParams] as const,
        update: () => [...dealQueryKeys.inWorkOrFinishedDeals.all(), 'update'] as const,
    },
};
